<template>
  <div class="organization">
    <BForm :key="organization.id" novalidate>
      <FormWrapper :validator="$v.organization">
        <form-group name="name">
          <template slot-scope="{ validator }">
            <OrganizationTypeAheadControl
              v-if="canSelect"
              id="organization-name"
              v-model="organization.name"
              description="Wpisz co najmniej 2 znaki. Po rozwinięciu użyj strzałek góra dół, aby zaznaczyć opcję. Użyj klawisza enter, aby wybrać. Jeśli na liście nie ma Twojej organizacji to wpisz pełną nazwę."
              label="Nazwa organizacji"
              :min-length="2"
              :select-first="false"
              @input="touch(validator)"
              @update:item="selectOrganization"
            />
            <InputControl
              v-if="!canSelect"
              id="organization-address"
              v-model="organization.name"
              label="Nazwa organizacji"
              :all-caps-ratio="0.1"
              :disabled="!canEdit"
              @input="touch(validator)"
            />
          </template>
        </form-group>

        <div class="row">
          <div class="col-md-6">
            <form-group name="vatid">
              <template slot-scope="{ validator }">
                <InputControl
                  id="organization-vatid"
                  v-model="organization.vatid"
                  label="NIP"
                  :disabled="!canEditField('vatid')"
                  @input="touch(validator)"
                />
              </template>
            </form-group>
          </div>
          <div class="col-md-6">
            <form-group name="krs">
              <template slot-scope="{ validator }">
                <InputControl
                  id="organization-krs"
                  v-model="organization.krs"
                  label="KRS"
                  :disabled="!canEditField('krs')"
                  @input="touch(validator)"
                />
              </template>
            </form-group>
          </div>
        </div>

        <form-group name="address">
          <template slot-scope="{ validator }">
            <InputControl
              id="organization-address"
              v-model="organization.address"
              label="Adres"
              :disabled="!canEditField('address')"
              @input="touch(validator)"
            />
          </template>
        </form-group>

        <div class="row">
          <div class="col-md-4">
            <form-group name="zip">
              <template slot-scope="{ validator }">
                <InputControl
                  id="organization-zip"
                  v-model="organization.zip"
                  label="Kod pocztowy"
                  :disabled="!canEditField('zip')"
                  @input="touch(validator)"
                />
              </template>
            </form-group>
          </div>
          <div class="col-md-8">
            <form-group name="city">
              <template slot-scope="{ validator }">
                <InputControl
                  id="organization-city"
                  v-model="organization.city"
                  label="Miejscowość"
                  :disabled="!canEditField('city')"
                  @input="touch(validator)"
                />
              </template>
            </form-group>
          </div>
        </div>
        <form-group name="phone">
          <template slot-scope="{ validator }">
            <InputControl
              id="organization-phone"
              v-model="organization.phone"
              label="Główny telefon"
              :disabled="!canEditField('phone')"
              @input="touch(validator)"
            />
          </template>
        </form-group>
        <form-group name="email">
          <template slot-scope="{ validator }">
            <InputControl
              id="organization-email"
              v-model="organization.email"
              label="Główny adres email"
              :disabled="!canEditField('email')"
              @input="touch(validator)"
            />
          </template>
        </form-group>

        <div class="row">
          <div class="col-md-12 text-right">
            <btn variant="primary" :icon="saveBtnIcon" @click="submit()">{{
              saveBtnText
            }}</btn>
          </div>
        </div>
      </FormWrapper>
    </BForm>
  </div>
</template>

<script>
import clone from "lodash/clone";
import OrganizationForm from "./OrganizationForm";
import BaseForm from "@/components/Base/Form/BaseForm";
import OrganizationTypeAheadControl from "@/components/Controls/OrganizationTypeAheadControl";
import ModelFactory from "@/model/ModelFactory";

const _ = { clone };

export default {
  name: "OrganizationFormModal",
  components: {
    OrganizationTypeAheadControl
  },
  extends: OrganizationForm,
  props: {
    canSelect: {
      type: Boolean,
      default: false
    },
    saveLoaded: {
      type: Boolean,
      default: false
    },
    neverSave: {
      type: Boolean,
      default: false
    },
    saveBtnText: {
      type: String,
      default: "Zapisz"
    },
    saveBtnIcon: {
      type: String,
      default: "check"
    }
  },

  computed: {
    canEdit() {
      return !this.organization.id || (this.saveLoaded && this.organization.id);
    },
    canSave() {
      return this.canEdit || !this.organization.isLoadedComplete();
    }
  },
  watch: {
    value(newValue) {
      this[this.formName] = newValue;
    }
  },
  methods: {
    canEditField(fieldName) {
      const canEdit =
        this.canEdit || !this.organization.isLoadedComplete(fieldName);
      // if (canEdit) {
      //   this.saveLoaded = true;
      // }
      return canEdit;
    },
    afterSubmit(res) {
      return res;
    },
    selectOrganization(organization) {
      let organizationName = this.organization.name;

      this.organization = ModelFactory.create(
        "OrganizationModel",
        _.clone(organization)
      );

      // if organization object empty, set name field to old value
      this.$set(this.organization, "name", organizationName);
      this.$emit("organization:selected", this.organization);
    },
    submit() {
      if (!this.neverSave && this.canSave) {
        return BaseForm.methods.submit.call(this);
      } else {
        this.$emit("form:selected", this.organization);
      }
    }
    // realSubmit() {
    //   console.log("realSubmit", this.canEdit, this.organization.isAnyDirty());
    //   if (this.canEdit ) {
    //     return BaseForm.methods.realSubmit.call(this);
    //   } else {
    //     return new Promise(() =>
    //       this.$emit("form:selected", this.organization)
    //     );
    //   }
    // }
  }
};
</script>
